export const cartQuery = `
  cart {
    id
    items {
      subscription {
        amount
        name
        size
        volume
        volumeUnit
        volumeNotes
        price
      }
      products {
        id
        amount
        brand
        name
        url
        volume
        volumeUnit
        category
        type
        offer
        image
        price
        needDiscountOffer
        discount
        totalPrice
        totalPriceWithDiscount
      }
    }
    price
    discount
    shipping
    appliedPriceRules {
      name
      value
    }
  }
`

export const meQuery = `
  me {
    id
    birthday
    email
    firstName
    lastName
    gender
    skinType
    ageCategory
    avatar
    registrationDate
    gaClientUid
    mixpanelClientUid
    hasGift
    hasPaymentData
    hasLimitedEditionProductInFirstMonth
    subUnpaid
    hasMarketingCoupon
    paymentOption
    isCrawler
    paymentStatus
    balance
    credits {
      ecommerce
    }
    shipping {
      firstName
      lastName
      street
      apt
      zipCode
      state
      city
      telephone
    }
    billing {
      firstName
      lastName
      street
      apt
      zipCode
      state
      city
      telephone
    }
    hasFinishedQuiz
    finishedQuiz
    fbPixelProperties {
      em
      fn
      ln
      ph
      ge
      db
      ct
      st
      zp
      country
    }
    sessionId
  }
`

export const subscriptionQuery = `
  subscription {
    id
    addressStatus
    status {
      name
      value
      statusText
      subscribed
    }
    plan {
      name
      price
      billingPeriod
      shippingPeriod
      productsPerPeriod
      frequency
      description
    }
    credits {
      total
      onBalance
      paid
      free
      freeForReferral
      freeForReferee
      freeCoupon
      freeGift
    }
    nextShippingDate {
      from
      to
    }
    subscriptionDate
    nextBillingDate
    balance
    inCart
    frequencyChangeable
    skippable
    upgradable
    cancelable
    isResubscribed
    unsubscribeFeedbackSentDate
  }
`

export const redeemCouponQuery = `
  redeemCoupon {
    code
    coupon
    type
    shouldCharge
    chargeAmount
    months
  }
`

export const closedPopupsQuery = `
  closedPopups {
    name
    lastUpdate
    count
  }
`

export const flashSaleQuery = `
  flashSale {
    id
    name
    price
    gender
    discount
    timeLeft
    startDate
    media {
      preview
    }
    tradingItem {
      id
    }
    products {
      id
      name
      brand
      image
      description
      price
      rating
    }
  }
`
